import { createContext, useContext, useState, useMemo } from "react";

/**
 * The navigation destinations the current user is actually allowed to open.
 *
 * SideBar already derives this through ~250 lines of role, permission,
 * department and feature-flag rules. Rather than duplicate that anywhere else
 * — which would drift, and could offer someone a route they can't open — the
 * sidebar publishes its computed list here and other features read it.
 *
 * Consumers get whatever the sidebar last rendered, so the two can never
 * disagree about what this user can reach.
 */
const NavItemsContext = createContext({ navItems: [], setNavItems: () => {} });

export function NavItemsProvider({ children }) {
  const [navItems, setNavItems] = useState([]);
  const value = useMemo(() => ({ navItems, setNavItems }), [navItems]);
  return <NavItemsContext.Provider value={value}>{children}</NavItemsContext.Provider>;
}

export function useNavItems() {
  return useContext(NavItemsContext);
}
